import type { ScaleVariant } from "@common/helpers/scaleInput";
import type { UserSettings } from "@common/types/User";

type UnitPreference = UserSettings["unitPreference"];

const HARVEST_WEIGHT_UNIT_KEY = "harvest_weight_unit";

const HARVEST_WEIGHT_UNITS: Record<UnitPreference, { small: string; big: string }> = {
  imperial: { big: "lb", small: "oz" },
  metric: { big: "kg", small: "g" }
};

const HARVEST_SCALE_FORMATS: Record<UnitPreference, ScaleVariant[]> = {
  imperial: ["lb", "oz", "lbOz"],
  metric: ["kg", "g"]
};

export const harvestScaleFormats = (unitPreference: UnitPreference) =>
  HARVEST_SCALE_FORMATS[unitPreference];

export const harvestWeightUnits = (unitPreference: UnitPreference) =>
  HARVEST_WEIGHT_UNITS[unitPreference];

export const harvestWeightUnitKey = (cropId?: number): string =>
  cropId != null ? `${HARVEST_WEIGHT_UNIT_KEY}_${cropId}` : HARVEST_WEIGHT_UNIT_KEY;

export const storedScaleFormat = (
  stored: string | null,
  unitPreference: UnitPreference,
  fallback: ScaleVariant
): ScaleVariant =>
  harvestScaleFormats(unitPreference).find((format) => format === stored) ?? fallback;
